import { render } from "./UserDeleteForm.vue?vue&type=template&id=795bb28b"
import script from "./UserDeleteForm.vue?vue&type=script&lang=js"
export * from "./UserDeleteForm.vue?vue&type=script&lang=js"
script.render = render

export default script